import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Task\GetTaskByIdController::__invoke
* @see app/Http/Controllers/Task/GetTaskByIdController.php
* @route '/api/task/{task}'
*/
const GetTaskByIdController = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTaskByIdController.url(args, options),
    method: 'get',
})

GetTaskByIdController.definition = {
    methods: ["get","head"],
    url: '/api/task/{task}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Task\GetTaskByIdController::__invoke
* @see app/Http/Controllers/Task/GetTaskByIdController.php
* @route '/api/task/{task}'
*/
GetTaskByIdController.url = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { task: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { task: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            task: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        task: typeof args.task === 'object'
        ? args.task.id
        : args.task,
    }

    return GetTaskByIdController.definition.url
            .replace('{task}', parsedArgs.task.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Task\GetTaskByIdController::__invoke
* @see app/Http/Controllers/Task/GetTaskByIdController.php
* @route '/api/task/{task}'
*/
GetTaskByIdController.get = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetTaskByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Task\GetTaskByIdController::__invoke
* @see app/Http/Controllers/Task/GetTaskByIdController.php
* @route '/api/task/{task}'
*/
GetTaskByIdController.head = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetTaskByIdController.url(args, options),
    method: 'head',
})

export default GetTaskByIdController